// Bound separately and synchronously (not inside the async block below) so
// selecting a performance time works immediately on page load, without
// waiting on the translations requests to resolve - the event delegation
// below only needs '.time-event' to exist in the DOM, and forwards to
// fetchPerformanceTickets() once it's exposed (see the async block).
jQuery( ( $ ) => {
	$( '.time-event' ).on( 'click', '.performance-time', function( event ) {
		event.preventDefault();

		if ( $( this ).find( 'a' ).hasClass( 'no-availability-border-color' ) ) {
			return;
		}
		$( '.performance-time' ).not( this ).removeClass( 'active' );
		$( '.performance-time a' ).not( this ).removeClass( 'active' );
		$( 'a', this ).addClass( 'active' );
		$( this ).addClass( 'active' );
		if ( window.eventPageFetchPerformanceTickets ) {
			window.eventPageFetchPerformanceTickets();
		}
	} );

	// Same reasoning as above: none of this reads translations, so it's
	// bound immediately rather than waiting on the async block's requests.
	// Showing/hiding the add-to-basket button on qty change, and handling
	// its click, would otherwise race the translations fetch the same way
	// the merchandise/vouchers/donations add-to-basket buttons did.
	const language = $( '#currentLanguage' ).val() || 'en';
	const defaultLanguage = $( '#defaultLanguage' ).val();

	$( '.tickets-main' ).on( 'click', '.back-to-calendar', function( event ) {
		event.preventDefault();
		const splitPath = window.location.pathname.replace( /\/$/, '' ).split( '/' );
		window.location.href = `/${  splitPath.slice( 1, splitPath.length - 1 ).join( '/' )}/`;
	} ).on( 'change', '.qty', function() {
		let totalTickets = 0;
		$( '.tickets-main .qty' ).each( function() {
			totalTickets = parseInt( $( this ).val() ) + totalTickets;
		} );

		if ( 0 < totalTickets ) {
			$( '.checkout-buttons .add-to-basket' ).removeClass( 'd-none' );
		}
		else {
			$( '.checkout-buttons .add-to-basket' ).addClass( 'd-none' );
		}
	} ).on( 'click', '.add-to-basket', async function( event ) {
		event.preventDefault();
		if ( !window.eventPageAddToBasket ) {
			return;
		}
		$( '#add-to-basket-spinner' ).removeClass( 'd-none' );
		$( '#add-to-basket-text' ).addClass( 'd-none' );
		let isValid = true;
		// validate the value for any pwyl amounts added
		$( '.pay-what-you-like-amount-in-table' ).each( function() {
			// validate that the customer has provided a numric value
			isValid = window.eventPageValidatePayWhatYouWantAmount( $( this ).val() );
			if ( !isValid ) {
				// break out of the each loop
				return false;
			}
		} );

		if ( !isValid ) {
			// dont continue
			return;
		}

		const response = await window.eventPageAddToBasket();
		window.eventPageUpdateBasketMessage( response.message );
		if ( response.basket ) {
			$( '.checkout-buttons .checkout' ).removeClass( 'd-none' );
			$( '.cart-btn .price' ).text( response.basket.total );

			$( '.tickets-main input.qty' ).each( function() {
				$( this ).val( 0 );
			} );
			if ( $( this ).hasClass( 'checkout' ) ) {
				let languagePathParam = '';
				if ( language !== defaultLanguage ) {
					languagePathParam = `/${language}`;
				}

				window.location.href = `${languagePathParam}/basket`;
			}
		}
	} );
} );

jQuery( async ( $ ) => {

	// These are hoisted function declarations (defined further down this
	// same scope), so the references are already valid here - exposing
	// them before the translations requests below lets the synchronously-
	// bound handlers above call them immediately, without waiting on the
	// translations requests to resolve. None of these three read
	// `translations` in a way that can throw (validatePayWhatYouWantAmount
	// only uses it for an error message, with an English fallback).
	window.eventPageFetchPerformanceTickets = fetchPerformanceTickets;
	window.eventPageAddToBasket = addToBasket;
	window.eventPageUpdateBasketMessage = updateBasketMessage;
	window.eventPageValidatePayWhatYouWantAmount = validatePayWhatYouWantAmount;

	( () => {
		if ( 992 < window.innerWidth ) {
			$( '.home-main-mobile-container' ).empty();
		} else {
			$( '.home-main-desktop-container' ).empty();
		}
	} )();

	let fetchingPerformanceTickets = false;

	const language = $( '#currentLanguage' ).val() || 'en';
	const defaultLanguage = $( '#defaultLanguage' ).val();

	// Falls back to an empty object (templates already have '|| "English
	// default"' fallbacks throughout) so nothing below can throw if it's
	// somehow reached before the translations requests resolve.
	let translations = window.translations || {};

	const eventTranslations = await $.get( red61.ajax_url, { action: 'get_translations', component: 'event' } );
	const dateTranslations = await $.get( red61.ajax_url, { action: 'get_translations', component: 'date' } );

	translations = eventTranslations.translations;

	window.translations = {
		...eventTranslations.translations,
		...dateTranslations.translations
	};

	window.currentLanguage = language;
	window.defaultLanguage = defaultLanguage;

	moment.locale( dateTranslations.language, dateTranslations.translations );

	let performanceData = $( '#event-data' ).data( 'performances' );
	const performanceDataConst = $( '#event-data' ).data( 'performances' );

	const performanceTemplate = _.template(
		'<li class=\'performance-time\' data-availability="<%- availability %>" data-id="<%- id %>" data-date="<%- performanceDate %>" data-reserved="<%- reserved %>" data-title="<%- title %>" data-description="<%- description %>" data-content-url="<%- contentUrl %>" data-admission-time="<%- admissionTime %>" data-presentation-format="<%- presentationFormat %>" >' +
			'<a href=#" class="btn btn-hover-darker btn-perf-time white-text green-bg <%- cssClass %>-bg-color <%- cssClass %>-border-color">' +
				'<div>' +
					'<span class="d-none spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><%- performanceTime %>'+
					'<% if (translatedPresentationFormat) { %>' +
						'<div><%- translatedPresentationFormat %></div>'+
					'<% } %>' +
				'</div>' +
			'</a>' +
		'</li>' );

	// Availability is loaded using the loadPerformanceAvailability() which finds the div by data-id and attaches relevent class to it. 
	const performanceTemplateLoadsAvailabilityOnClick = _.template(
		'<li class=\'performance-time\' data-title="<%- title %>"  data-reserved="<%- reserved %>"  data-id="<%- id %>" data-date="<%- performanceDate %>"  data-presentation-format="<%- presentationFormat %>" >' +
			'<a href=#">' +
				'<div>' +
					'<span class="d-none spinner-border spinner-border-sm" role="status" aria-hidden="true"></span><%- performanceTime %>'+
					'<% if (translatedPresentationFormat) { %>' +
						'<div><%- translatedPresentationFormat %></div>'+
					'<% } %>' +
				'</div>' +
			'</a>' +
		'</li>'
	);

	const eventTicketTemplateHeader = _.template(
		'<th> <%- translations[ "Ticket Type" ] || "Ticket Type" %></th>' +
		'<th><%- translations[ "Price" ] || "Price" %></th>' +
		'<th> <%- translations[ "Qty" ] || "Qty" %></th>'
	);

	const displayTags = _.template(
		'<% for (let x = 0; x < tags.length ; x++) { %>' +
			'<p class="pre-performance-tags"><%- tags[x]["additionalInfo"] %></p>' +
			'<% } %>'
	);

	const getAccessButtonForm = _.template(
		'<input type="hidden" name="priceId" value="<%- priceId %>" >' +
		'<input type="hidden" name="perfId" value="<%- perfId %>" >' +
		'<button class="btn-standard btn-primary-bg-color btn-get-access" type="submit">' +
			'<%- translations[ "GET ACCESS" ] || "GET ACCESS" %>' +
		'</button>'
	);

	const feesSummaryBlock =
		'<% if (doFeesExist) { %>' +
			'<% if (inclusiveFees) { %>' +
				'<% if (feeDetailsArray.length > 1) { %>' +
					'<p><%- translations[ "inc" ]|| "inc" %> <%- totalFeesFormatted %> <%- translations[ "fees" ]|| "fees" %></p>' +
				'<% } else if (feeDetailsArray.length === 1) { %>' +
					'<p><%- translations[ "inc" ]|| "inc" %> <%- feeDetailsArray[0] %></p>' +
				'<% } %>' +
			'<% } else { %>' +
				'<% for (let x = 0; x < feeDetailsArray.length ; x++) { %>' +
					'<p>+ <%- feeDetailsArray[x] %></p>' +
				'<% } %>' +
			'<% } %>' +
		'<% } %>';

	const pwylFeesSummaryBlock =
		'<% if (doFeesExist) { %>' +
			'<% if (inclusiveFees) { %>' +
				'<p class="pwyl-inclusive-total"><%- ticketPriceTotalWithCurrency %></p>' +
				'<% if (feeDetailsArray.length > 1) { %>' +
					'<p><%- translations[ "inc" ]|| "inc" %> <%- totalFeesFormatted %> <%- translations[ "fees" ]|| "fees" %></p>' +
				'<% } else if (feeDetailsArray.length === 1) { %>' +
					'<p><%- translations[ "inc" ]|| "inc" %> <%- feeDetailsArray[0] %></p>' +
				'<% } %>' +
			'<% } else { %>' +
				'<div class="pwyl-fees-list">' +
					'<% for (let x = 0; x < feeDetailsArray.length ; x++) { %>' +
						'<p>+ <%- feeDetailsArray[x] %></p>' +
					'<% } %>' +
				'</div>' +
			'<% } %>' +
		'<% } %>';

	const eventTicketTemplate = _.template(
		`${'<tr class="<%- cssClassWithNoSpaces %>-test-cypress"></tr>' +
		'<tr class="<%- cssClassWithNoSpaces %>-test-cypress">' +
		'<td data-label="<%- translations[ "Ticket type" ] || "Ticket type" %>"><h3 class="primary-color"><%- titleUpdate %></h3> <% if (priceOverrideAvailable == true) { %><p class="black-text">(Minimum <%- minOverridePrice %>)</p><% } %>' +
		'<% if (descriptionUpdate.length > 1) { %>' +
			'<p><%- descriptionUpdate %></p>' +
		'<% } %>' +
		'<% if (promoCodeRequired) { %>' +
		'<label><%- translations[ "Promotion code" ] || "Promotion code" %>: <input style="width: auto;height: 36px;" type="text" name="promocode[<%- priceId %>]" class="promocode" value=""></label>' +
		'<% } %>' +
		'<% if (descriptionUpdate.length > 1) { %>' +
			'<% if (priceOverrideAvailable != true) { %>' +
				'<td data-label="<%- translations[ "Price" ]|| "Price" %>">' +
	'<h3 class="black-text"><%- ticketPriceTotalWithCurrency %> </h3>'}${ 
			feesSummaryBlock 
		}<% } else { %>` +
	'<td data-label="<%- translations[ "Price" ]|| "Price" %>">' +
		'<div class="pwyl-with-inclusive-price" data-fees="<%- totalFeesFloat %>" data-currency="<%- currencyFormat %>">' +
			'<div class="pwyl-input-field-in-table">' +
				'<input type="number" name="pwyl_amount[<%- priceId %>]" class="pay-what-you-like-amount-in-table input-border" value="<%- pwylSuggestedValue %>">' +
				'<p class="pwyl-currency-symbol-in-table" ><%- currencyFormat %></p>' +
			`</div>${ 
				pwylFeesSummaryBlock 
			}</div>` +
	'</td">' +
'<% } %>' +
'<% } else { %>' +
	'<% if (priceOverrideAvailable != true) { %>' +
		'<td class="padding-to-centre-with-ticket-type-col" data-label="<%- translations[ "Price" ]|| "Price" %>">' +
		`<h3 class="black-text"> <%- ticketPriceTotalWithCurrency %> </h3>${ 
			feesSummaryBlock 
		}<% } else { %>` +
			'<td data-label="<%- translations[ "Price" ]|| "Price" %>">' +
				'<div class="pwyl-with-inclusive-price" data-fees="<%- totalFeesFloat %>" data-currency="<%- currencyFormat %>">' +
					'<div class="pwyl-input-field-in-table">' +
						'<input type="number" name="pwyl_amount[<%- priceId %>]" class="pay-what-you-like-amount-in-table input-border" value="<%- pwylSuggestedValue %>">' +
						'<p class="pwyl-currency-symbol-in-table" ><%- currencyFormat %></p>' +
					`</div>${ 
						pwylFeesSummaryBlock 
					}</div>` +
			'</td">' +
	'<% } %>' +
'<% } %>' +
		'<td data-label="<%- translations[ "QTY" ] || "QTY" %>">' +
				'<% if (available && !isConcessionListOnly ) { %>' +
					'<select name="qty[<%- priceId %>]" class="qty">' +
						'<option value="0"></option>' +
						'<% for (let i = minimumQty; i <= 20; i++) { %>' +
							'<option value="<%- i %>"><%- i %></option>' +
						'<% } %>' +
					'</select>' +
				'<% }  else if  ( isConcessionListOnly ) { %>' +
					'<div><%- translations[ "Not available online" ] || "Not available online" %></div>' +
				'<% } else { %>' +
					'<div><%- translations[ "Unavailable" ] || "Unavailable" %></div>' +
				'<% } %>' +
			'</td>' +
		'</tr>' );

	let seatPlanCache, zoom = 2.5; // eslint-disable-line
	const vw = Math.max( document.documentElement.clientWidth, window.innerWidth || 0 );

	if( 600 > vw ) {
		zoom = 2;
	}

	const performanceDataDigitalOnDemand = { dates:[], Object, data:[] };
	const performanceDataWithDates = { dates:[], Object, data:[] };

	if ( performanceData ) {

		performanceDataDigitalOnDemand.times = performanceData.times;
		performanceDataWithDates.times = performanceData.times;
		const arrayLength = performanceData.dates.length;
		for ( let i = 0; i < arrayLength; i++ ) {
			if ( null == performanceData.dates[i] ) {
				// digital on demand
				performanceDataDigitalOnDemand.dates.push( performanceData.dates[i] );
				performanceDataDigitalOnDemand.data.push( performanceData.data[i] );
			} else {
				// performance time
				performanceDataWithDates.dates.push( performanceData.dates[i] );
				performanceDataWithDates.data.push( performanceData.data[i] );
			}
		}	
	}

	performanceData = performanceDataWithDates;

	if ( null != performanceData.dates[0] ) {

		// display the calendar for presentation formats that have performance dates/times.

		const splitFirstDate = performanceData.dates[0].split( '/' );

		const datepicker = $( '#datetimepicker2-event' );

		const { weekdays, weekdaysShort, weekdaysMin, months, monthsShort, today, clear, format, titleFormat, weekStart } = dateTranslations.translations;

		$.fn.datepicker.dates[dateTranslations.language] = {
			days: weekdays,
			daysShort: weekdaysShort,
			daysMin: weekdaysMin,
			months,
			monthsShort,
			today,
			clear,
			format,
			titleFormat,
			weekStart
		};

		datepicker.datepicker( {
			inline: true,
			multidate: false,
			startDate: performanceData.dates[0],
			endDate: performanceData.dates[performanceData.dates.length - 1],
			format: 'dd/mm/yyyy',
			weekStart,
			language: dateTranslations.language,
			defaultViewDate: {
				year: splitFirstDate[2],
				month: parseInt( splitFirstDate[1] ) - 1,
			},
			beforeShowDay: function( date ) {
				return beforeShowDatepickerDay( date );
			},
		} ).on( 'changeDate', ( event ) => {
			displayPerformanceTimesForDate( event );
		} );

		$( '.event-schedule' ).removeClass( 'd-none' );
	}

	if ( 0 < performanceDataDigitalOnDemand.dates.length ) {
		displayDigitalOnDemand();
	}

	/**
	 * This is not using the legacy underscore js framework as used at the top of the page.
	 * It is doing it in pure js.
	 */
	function constructDigitalOnDemand( onDemandData ) {
		let available = true;
		const {cssClass} = onDemandData;
		if ( 'no-availability' == cssClass ) {
			// cancelled in the client, or no more seats (although this should not happen for digital on demand)
			available = false;
		}

		const {id} = onDemandData;
		const {title} = onDemandData;
		const {publishDateTime} = onDemandData;

		const a = document.createElement( 'a' );
		if ( available ) {
			a.setAttribute( 'class', 'primary-color-background on-demand-a' );
		} else {
			a.setAttribute( 'class', 'no-availability on-demand-a disabled' );
		}
		const eventPath = getEventPathFromHref();
		a.href = eventPath + id;

		const titleDiv =  document.createElement( 'div' );
		if ( null != title && '' != title ) {
			titleDiv.textContent = title;
		} else {
			titleDiv.textContent = translations['Watch now'] || 'Watch now';
		}
		titleDiv.setAttribute( 'class', 'on-demand-title' );

		const publishDateDiv =  document.createElement( 'div' );
		publishDateDiv.textContent = translatePublishedFromDateString( publishDateTime );
		publishDateDiv.setAttribute( 'class', 'on-demand-publish-date' );

		a.appendChild( titleDiv );
		a.appendChild( publishDateDiv );

		return a;
	}

	$( '.on-demand-a' ).hover( function( ) {
		$( this ).addClass( 'secondary-bg-color' );
	} , function() {
		$( this ).removeClass( 'secondary-bg-color' );
	} );

	function getEventPathFromHref() {
		let eventPath = '';
		const splitPathArray = window.location.href.replace( /\/$/, '' ).split( '/' );

		let eventIdIndex = null;
		// establish the event id index by looking for the string 'event'
		for ( let i = splitPathArray.length-1; 0 <= i; i-- ) {
			if ( 'event' == splitPathArray[i] ) {
				eventIdIndex = i + 2;
				break;
			}
		}

		// construct the event url
		for ( let i = 0; i < eventIdIndex; i++ ) {
			if ( i < eventIdIndex ) {
				eventPath += `${splitPathArray[i]  }/`;
			} else {
				break;
			}
		}

		return eventPath;
	}

	function translatePublishedFromDateString( date ){
		if ( null != date ) {
			const dateTimeNow = new Date();
			const today = new Date( dateTimeNow.getFullYear(), dateTimeNow.getMonth(), dateTimeNow.getDate() );

			let dateSplitIntoArray = date.split( ' ' );
			const datePartArray = dateSplitIntoArray[0];
			dateSplitIntoArray = datePartArray.split( '-' );
			const publishDate = new Date( dateSplitIntoArray[0], dateSplitIntoArray[1] - 1, dateSplitIntoArray[2] );

			const publishDateInFuture = publishDate > today;
			if ( publishDateInFuture ) {
				const month = new Intl.DateTimeFormat( 'en', { month: 'long' } ).format( publishDate );
				const day = new Intl.DateTimeFormat( 'en', { day: 'numeric' } ).format( publishDate );
				const translatedFrom = translations[ 'From' ];
				const translatedDateMonth = translations[ month ];
				const translatedPublishDate = ` ${translatedFrom  } ${day  } ${  translatedDateMonth}`;
				return translatedPublishDate;
			}
		}
	}

	function displayDigitalOnDemand() {
		const dodLength = performanceDataDigitalOnDemand['times'][''].length;
		for ( let i = 0; i < dodLength; i++ ) {
			const onDemand = performanceDataDigitalOnDemand['times'][''][i];
			$( '.on-demand-container' )
				.append( constructDigitalOnDemand( onDemand ) );
		}
		if ( 0 < dodLength ) {
			$( '.main-on-demand-container ' ).removeClass( 'd-none' );
		}
	}

	function beforeShowDatepickerDay( date ) {

		const momentDate = moment( date );
		const actualDate = momentDate.format( 'DD/MM/YYYY' );

		if ( red61.show_availability_in_calendar ) {
			if ( performanceData.times[actualDate] ) {
				let performanceTitlesString = '';
				const showPerformanceTitle = parseInt( $( '#customizations' ).data( 'show-performance-title' ) );
	
				if ( showPerformanceTitle ) {
					const performanceTitles = [];
	
					performanceData.times[actualDate].forEach( ( performance ) => {
						if ( performance.title ) {
							performanceTitles.push( performance.title );
						}
					} );
	
					if ( 0 < performanceTitles.length ) {
						performanceTitlesString = `(${performanceTitles.join( ', ' )})`;
					}
				}
	
				const hasAvailabilityFunc = ( performance ) => 'green' == performance.cssClass;
				const hasSomeAvailabilityFunc = ( performance ) => 'low-availability' == performance.cssClass;
				const calenderDatehasGoodAvailability = performanceData.times[actualDate].some( hasAvailabilityFunc );
				const calenderDateHasSomeAvailability = performanceData.times[actualDate].some( hasSomeAvailabilityFunc );
	
				// This returns what color the calender date should be
				// If any of the dates are green then it will display green
				if ( calenderDatehasGoodAvailability ) {
					return {
						tooltip: `${translations[ 'Date available' ] || 'Date available'}${ performanceTitlesString }`,
						enabled: true,
						classes: 'green',
					};
				// If some or all are low availibility then it will display orange
				} else if ( calenderDateHasSomeAvailability ) {
					return {
						classes: 'low-availability-bg-color',
					};
				} else {
					return {
						enabled: false,
						tooltip: `${translations[ 'Date sold out' ] || 'Date sold out'}${ performanceTitlesString }`,
						classes: 'red',
					};
				}
	
			}
			else {
				return {
					tooltip: translations[ 'No performances today' ] || 'No performances today',
					enabled: false,
				};
			}
		} else {
			if ( performanceData.dates.includes( actualDate ) ) {
				return {
					tooltip: `${translations[ 'Date available' ] || 'Date available'}`,
					enabled: true,
					classes: 'green',
				};
			} else {
				return {
					tooltip: translations[ 'No performances today' ] || 'No performances today',
					enabled: false,
				};
			}
		}
		
	}

	async function loadPerformanceAvailability( performanceId ) {
		// Uses getPerformancePrices() which has a 30 minute cache so limited availability takes 30 mins to come through

		// display the key of performance availability
		$( '.perf-time-availability' ).attr( 'style', 'display:block;' );

		const data = {
			'action': 'get_perf_availability',
			'performanceId': performanceId
		};
		$.post( red61.ajax_url, data, function( availability ) {
			if ( 'available' == availability ) {
				$( `[data-id="${ performanceId }"]` ).find( 'a' ).attr( 'class', 'btn btn-width-auto green-bg btn-standard white-text green-border-color' );
				$( `[data-id="${ performanceId }"]` ).find( 'a .button-text-inner' ).removeClass( 'primary-color' );
			} else if ( 'low-availability' == availability ) {
				$( `[data-id="${ performanceId }"]` ).find( 'a' ).attr( 'class', 'btn btn-width-auto low-availability-bg-color btn-standard white-text low-availability-border-color' );
				$( `[data-id="${ performanceId }"]` ).first( 'div' ).attr( 'class', 'btn low-availability-bg-color low-availability-border-color button-bg' );
			} else {
				$( `[data-id="${ performanceId }"]` ).find( 'a' ).attr( 'class', 'btn btn-width-auto no-availability-bg-color btn-standard white-text no-availability-border-color' );
				$( `[data-id="${ performanceId }"]` ).first( 'div' ).attr( 'class', 'btn no-availability-bg-color no-availability-border-color button-bg' );
			}
			$( `[data-id="${ performanceId }"]` ).attr( 'class', 'performance-time' );
		} );
	}

	async function getPerformancesOnSpecificDay( event ){
	
		const selectedDateFormattedForSoap = moment( event.date ).format( 'YYYY-MM-DD 00:00:00' );
		const selectedDateNextDay = moment( event.date, 'YYYY-MM-DD 00:00:00' ).add( 1, 'days' ).add( -1, 'seconds' );

		const selectedDateNextDayFormattedForSoap = moment( selectedDateNextDay ).format( 'YYYY-MM-DD HH:mm:ss' );
		const formData = new FormData();
		formData.append( 'action', 'get_performances_for_one_day' );
		formData.append( 'selectedDateFormattedForSoap', selectedDateFormattedForSoap );
		formData.append( 'selectedDateNextDayFormattedForSoap', selectedDateNextDayFormattedForSoap );
		formData.append( 'eventId', performanceDataConst.eventId );

		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} );
		return response;
	}

	function displayPerformanceTimesForDate( event ) {

		// Making the DOM display items / not display items as needed 
		$( '.tickets-btn' ).addClass( 'd-none' );

		const $performances = $( '.performances' );
		$performances.show();
		$( 'h3 span', $performances )
			.html( moment( event.date ).format( 'Do MMMM YYYY' ) );
		$( '.time-event', $performances ).html( '' );


		const performanceData = $( '#event-data' ).data( 'performances' );
		if ( '' != performanceData.times ) {
			// Performance data is in the dom, fetch it from there
			loadPerformancesFromDataInDOM( event, $performances );

		} else {
			// Performance data is not in the DOM, make an AJAX request to fetch it
			loadPerformancesForSpecifDayWithAjaxRequest( event, $performances );
		}
		
	}

	async function loadPerformancesForSpecifDayWithAjaxRequest( event, $performances ) {

		const performancesOnSpecificDay = await getPerformancesOnSpecificDay( event );

		const displayDigitalFormat = red61.display_presentation_format_for_digital;
		const displayInPersonFormat = red61.display_presentation_format_for_in_person;

		$( '.time-event', $performances ).empty();

		performancesOnSpecificDay.forEach( ( performanceData ) => {

			// This function finds the performance element by id and adds the correct class to it
			const presentationFormat = performanceData['presentationFormat'];
			performanceData['translatedPresentationFormat'] = null;
			if ( isPresentationFormatTypePopulated( presentationFormat ) ) {
				if ( ( isPresentationFormatTypeDigital( presentationFormat ) && displayDigitalFormat ) || ( !isPresentationFormatTypeDigital( presentationFormat ) && displayInPersonFormat ) ) {
					const translatedPresentationFormat = translatePresentationFormatFromType( presentationFormat );
					performanceData['translatedPresentationFormat'] = translatedPresentationFormat;
				}
			}

			loadPerformanceAvailability( performanceData.id );
			$( '.time-event', $performances )
				.append( performanceTemplateLoadsAvailabilityOnClick( { ...performanceData, translations } ) );
		} );
	}

	function loadPerformancesFromDataInDOM( event, $performances ) {

		const selectedDate = moment( event.date ).format( 'DD/MM/YYYY' );
		const performanceTimesFromSelectedDate = performanceData.times[selectedDate];
		// const {hasPerformanceDataLoaded} = performanceData;

		const displayDigitalFormat = red61.display_presentation_format_for_digital;
		const displayInPersonFormat = red61.display_presentation_format_for_in_person;

		performanceTimesFromSelectedDate.forEach( ( performanceData ) => {
			const presentationFormat = performanceData['presentationFormat'];
			performanceData['translatedPresentationFormat'] = null;
			if ( isPresentationFormatTypePopulated( presentationFormat ) ) {
				if ( ( isPresentationFormatTypeDigital( presentationFormat ) && displayDigitalFormat ) || ( !isPresentationFormatTypeDigital( presentationFormat ) && displayInPersonFormat ) ) {
					const translatedPresentationFormat = translatePresentationFormatFromType( presentationFormat );
					performanceData['translatedPresentationFormat'] = translatedPresentationFormat;
				}
			}

			$( '.time-event', $performances )
				.append( performanceTemplate( { ...performanceData, translations } ) );
		} );

		const showPerformanceTitle = parseInt( $( '#customizations' ).data( 'show-performance-title' ) );
		if ( showPerformanceTitle ) {
			$( '.performance-time' ).each( function () {
				const performanceId = $( this ).data( 'id' );

				if ( performanceId ) {
					const buttonPerformance = performanceTimesFromSelectedDate.find( ( performance ) => performance.id === performanceId );

					if ( buttonPerformance.title ) {
						$( 'a.btn', this ).attr( 'title', buttonPerformance.title );
					}
				}
			} );
		}
		const waitingListElement = document.getElementById( 'waiting-list-container' );
		if( !waitingListElement ){
			const performanceTimeButtons = $( '.performance-time', $performances );
			if ( 1 === performanceTimeButtons.length ) {
				performanceTimeButtons.click();
			}
		}
	}

	/**
	 * Checks that the presentation format has been populated with a correct value.
	 * This is necessary for backwards compatibility with older version of core where presentationFormat does not exist.
	 *
	 * @param {*} presentationFormatType
	 */
	function isPresentationFormatTypePopulated( presentationFormatType ) {
		let result = false;
		if ( 'PHYSICAL' == presentationFormatType || 'DIGITAL_LIVE' == presentationFormatType || 'DIGITAL_CATCHUP' == presentationFormatType || 'DIGITAL_OD' == presentationFormatType ) {
			result = true;
		}
		return result;
	}

	/**
	 * Checks that if the presentation format has been populated, it is digital in nature.
	 *
	 * @param {*} presentationFormatType
	 */
	function isPresentationFormatTypeDigital( presentationFormatType ) {
		let result = false;
		if ( 'DIGITAL_LIVE' == presentationFormatType || 'DIGITAL_CATCHUP' == presentationFormatType || 'DIGITAL_OD' == presentationFormatType ) {
			result = true;
		}
		return result;
	}

	function translatePresentationFormatFromType( presentationFormatType ) {
		let translatedFormat = null;
		if ( 'PHYSICAL' == presentationFormatType ) {
			translatedFormat =  translations['In Person'] || 'In Person';
		} else if ( 'DIGITAL_LIVE' == presentationFormatType ) {
			translatedFormat =  translations['Digital - Live'] || 'Digital - Live';
		} else if ( 'DIGITAL_CATCHUP' == presentationFormatType ) {
			translatedFormat =  translations['Digital - Live + Catch up'] || 'Digital - Live + Catch up';
		} else if ( 'DIGITAL_OD' == presentationFormatType ) {
			translatedFormat =  translations['Digital - On Demand'] || 'Digital - On Demand';
		} else {
			translatedFormat =  presentationFormatType;
		}
		return translatedFormat;
	}

	function redirectToNewUrl( id ) {
		// Get the current URL
		const currentUrl = window.location.href;

		// Parse the URL to separate the path and query parameters
		const urlParts = currentUrl.split( '?' );
		const baseUrl = urlParts[0];

		// Append the id parameter before any existing query parameters
		const newUrl = `${baseUrl  }/${  id  }`;

		// Redirect to the new URL
		window.location.href = newUrl;
	}

	function fetchPerformanceTickets() {

		if ( fetchingPerformanceTickets ) {
			return;
		}

		fetchingPerformanceTickets = true;
		const $selectedPerf = $( '.performance-time.active' );
		const id = $selectedPerf.data( 'id' );
		const presentationFormat = $selectedPerf.data( 'presentation-format' );

		if ( 'DIGITAL_OD' !== presentationFormat ) {
			redirectToNewUrl( id );
			return;
		}
		const reserved = $selectedPerf.data( 'reserved' );
		const $spinner = $( '.spinner-border', $selectedPerf );
		$spinner.removeClass( 'd-none' );

		const action = reserved ? 'get_seating_plan' : 'get_perf_prices';

		const data = {
			'action': action,
			'performanceId': id,
		};

		$.post( red61.ajax_url, data, function( ticketPrices ) {
			$spinner.addClass( 'd-none' );

			const selectedPerformance = $( '.performance-time.active' );
			displayPerformanceTitle( selectedPerformance.data( 'title' ) );
			displayPerformanceDescription( selectedPerformance.data( 'description' ) );
			displayPerformanceDigitalContentLink( selectedPerformance.data( 'content-url' ) );
			displayPerformanceAdmissionTime( selectedPerformance.data( 'admissionTime' ) );

			if ( 'get_seating_plan' === action ) {
				processReservedTicketPrices(
					ticketPrices,
					selectedPerformance.data( 'date' ),
					selectedPerformance.data( 'id' )
				);

				fetchingPerformanceTickets = false;

				return;
			}

			processUnreservedTicketPrices(
				ticketPrices,
				selectedPerformance.data( 'date' ),
				selectedPerformance.data( 'id' ),
				presentationFormat
			);

			fetchingPerformanceTickets = false;
		} );
	}

	function displayPerformanceTitle( title ) {
		const $performanceTitle = $( '.performance-title' );
		if ( $performanceTitle.length ) {
			if ( title ) {
				$performanceTitle.text( `${title}` );
			} else {
				$performanceTitle.text( '' );
			}
		}
	}

	function displayPerformanceDescription ( description ) {
		const $performanceDescription = $( '.performance-description' );
		if ( $performanceDescription.length ) {
			if ( description ) {
				$performanceDescription.text( description );
			} else {
				$performanceDescription.text( '' );
			}
		}
	}

	function displayPerformanceDigitalContentLink ( digitalContentUrl ) {
		const $performanceDigitalContentLink = $( '.performance-digital-content-link' );

		if ( $performanceDigitalContentLink.length ) {
			if ( digitalContentUrl ) {
				$performanceDigitalContentLink.attr( 'href', digitalContentUrl );
				$performanceDigitalContentLink.removeClass( 'hidden' );
			} else {
				$performanceDigitalContentLink.attr( 'href', '#' );
				$performanceDigitalContentLink.addClass( 'hidden' );
			}
		}
	}

	function displayPerformanceAdmissionTime ( admissionTime ) {
		const $performanceAdmissionTime = $( '.performance-admission-time' );
		if ( $performanceAdmissionTime.length ) {
			if ( admissionTime ) {
				const addmissionTimeLabel = `${translations[ 'Admission Time' ]  }: ` || 'Admission Time' + ': ';
				$performanceAdmissionTime.text( addmissionTimeLabel + admissionTime );
			} else {
				$performanceAdmissionTime.text( '' );
			}
		}
	}

	function translateTicketPriceDate( date ){
		const dateSplitIntoArray = date.split( ' ' );
		const translatedDateNumber = translations[ dateSplitIntoArray[0] ];
		const translatedDateMonth = translations[ dateSplitIntoArray[1] ];
		const translatedDateFull = `${translatedDateNumber   } ${  translatedDateMonth  } ${  dateSplitIntoArray[2]  } ${  dateSplitIntoArray[3]} ${ 5 == dateSplitIntoArray.length ? dateSplitIntoArray[4] : ''}`;
		return translatedDateFull;
	}

	function processReservedTicketPrices( ticketPrices, date, id ) {

		const $seatingSection = $( '.event-schedule-seatmaps' );
		$seatingSection
			.removeClass( 'd-none' )
			.find( '.performance-date' )
			.text( translateTicketPriceDate( date ) );
		$seatingSection.find( '#performanceId' ).val( id );
		$( '.event-schedule' ).addClass( 'd-none' );
		$( '.main-on-demand-container' ).addClass( 'd-none' );


		const oldURL = window.sessionStorage.getItem( 'lastPage' );
		const thisUrl = window.location.href;

		if( oldURL !== thisUrl ) {
			window.sessionStorage.setItem( 'lastPage', window.location.href );
			window.location.reload();
		} else {
			window.sessionStorage.removeItem( 'lastPage' );
		}
	}

	function processUnreservedTicketPrices( ticketPrices, date, id, presentationFormat ) {

		$( '.event-schedule' ).addClass( 'd-none' );
		$( '.event-main .info-box' ).addClass( 'd-none' );
		const $ticketSection = $( '.tickets-main' );

		// Perfs that will be using this feature will only ever have 1 Priceband
		const priceId = ticketPrices[0]['priceId'];
		const perfId = id;

		// Check here if the user has already purchased this performance so it displays "Go to my Wallet instead"

		$ticketSection.removeClass( 'd-none' );
		$( '.main-on-demand-container' ).addClass( 'd-none' );

		// video on demand does not have a date
		if ( 'DIGITAL_OD' !== presentationFormat ) {
			$ticketSection
				.find( '.performance-date' )
				.text( translateTicketPriceDate( date ) );
		} else {
			$( '.select-ticket-type' ).addClass( 'd-none' );
		}

		$ticketSection.find( '#performanceId' ).val( id );

		$( '.ticket-info tbody' ).html( '' );

		$( '.get-access-button-wrapper' )
			.empty()
			.append( getAccessButtonForm( { priceId, perfId, translations } )
			);

		$( '.ticket-info thead' )
			.empty()
			.append( eventTicketTemplateHeader( { translations } )
			);

		let doFeesExist = false;

		// This loops through all the tickets & concessions to see if they have fees
		// Unreserved seating
		ticketPrices.forEach( ( ticketPrice ) => {
			const inclusiveFees = ticketPrice['inclusiveFees'];
			let i = 0;
			let totalFeesFloat= 0.00;
			let ticketPriceTotalWithCurrency = 0;
			let ticketPriceTotalWithDecimal = 0;
			let ticketFeeFloat = 0;
			let ticketPriceTotal = 0;
			const feeDetailsArray = [];
			const ticketPriceString = ticketPrice['price'];
			const currency = ticketPriceString.charAt( 0 );
			const ticketPriceStringWithoutCurrency = ticketPriceString.substring( 1 );
			const ticketPriceStringWithoutComma = ticketPriceStringWithoutCurrency.replace( /[^\d.]/g, '' );
			const ticketPriceFloat = parseFloat( ticketPriceStringWithoutComma );
			const priceOverrideAvailable = ticketPrice['priceOverrideAvailable'];
			const minOverridePrice = ticketPrice['minOverridePrice'];
			const remainingConcessionTickets = ticketPrice['remainingConcessionTickets'];
			if( remainingConcessionTickets != undefined && 1 > remainingConcessionTickets ) {
				ticketPrice['available'] = false;
			}
			const isConcessionListOnly = ticketPrice['isConcessionListOnly'];

			if( ticketPrice['feesTitle'] ){
				doFeesExist = true;
				ticketPrice['feesTitle'].forEach(  feesTitle => {
					if ( ticketPrice['feesValue'][i] ) {
						let ticketFeeString = ticketPrice['feesValue'][i];
						{ '0' == ticketFeeString.charAt( 0 ) ? ticketFeeString = ticketFeeString.substring( 1 ) : null; }
						ticketFeeFloat = parseFloat( ticketFeeString );
						totalFeesFloat = totalFeesFloat + ticketFeeFloat;
						const formattedFee = ticketFeeFloat.toFixed( 2 );
						feeDetailsArray.push( `${currency + formattedFee} ${feesTitle}` );
						i = i + 1;
					}
				} );
			}
			if( inclusiveFees ) {
				ticketPriceTotal = ticketPriceFloat + totalFeesFloat;
			}  else {
				ticketPriceTotal = ticketPriceFloat;
			}
			ticketPriceTotalWithDecimal = currency + ticketPriceTotal.toFixed( 2 );
			ticketPriceTotalWithCurrency = ticketPriceTotalWithDecimal.toString().replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
			const totalFeesFormatted = currency + totalFeesFloat.toFixed( 2 );

			const pwylSuggestedValue = ticketPriceFloat.toFixed( 2 );
			const title = ticketPrice['title'];
			const cssClassWithNoSpaces = title.replace( ' ', '-' );

			// currency format as set in the customizer
			const currencyFormat = red61.currency_format;

			//decode description from special characters
			const decodeEntities = ( function() {
				// this prevents any overhead from creating the object each time
				const element = document.createElement( 'div' );
				function decodeHTMLEntities ( str ) {
					if( str && 'string' === typeof str ){
						element.innerHTML = str;
						str = element.textContent;
						element.textContent = '';
					}
					return str;
				}
				return decodeHTMLEntities;
			} )();
			const descriptionUpdate = decodeEntities( ticketPrice['description'] );
			const titleUpdate = decodeEntities( ticketPrice['title'] );

			$( '.ticket-info tbody' )
				.append( eventTicketTemplate( { ...ticketPrice, titleUpdate, descriptionUpdate, priceOverrideAvailable, currencyFormat, cssClassWithNoSpaces, ticketPriceTotalWithCurrency, pwylSuggestedValue, doFeesExist, inclusiveFees, feeDetailsArray, totalFeesFloat, totalFeesFormatted, isConcessionListOnly, minOverridePrice, translations } ) );

		} );
	}

	// processs ticket prices if data is already on page
	const $perfDataFromServer = $( '#performance-prices' );
	if ( $perfDataFromServer.length ) {
		displayPerformanceTitle( $perfDataFromServer.data( 'title' ) );
		processUnreservedTicketPrices(
			$perfDataFromServer.data( 'performance-prices' ),
			$perfDataFromServer.data( 'date' ),
			$perfDataFromServer.data( 'id' ),
			$perfDataFromServer.data( 'presentation-format' )
		);
	}

	// processs ticket prices if data is already on page
	const $seatmapDataFromServer = $( '#performance-prices-seatmap' );
	if ( $seatmapDataFromServer.length ) {
		displayPerformanceTitle( $seatmapDataFromServer.data( 'title' ) );

		processReservedTicketPrices(
			$seatmapDataFromServer.data( 'performance-prices' ),
			$seatmapDataFromServer.data( 'date' ),
			$seatmapDataFromServer.data( 'id' )
		);
	}

	const selectedSeatTemplate = _.template( `
	<tr id="seat-row-<%- id %>">
		<td><%- block %></td>
		<td><%- row %></td>
		<td><%- number %></td>
		<td><%- type %></td>
		<td><a class="remove-seat" data-id="<%- id %>" data-priceband="<%- priceband %>" href="#"><% print( removesvg )%></a></td>
	</tr>
		` );

	function getHowManySelectedSeats() {
		return $( '#selected-seats tbody tr' ).length;
	}


	const updateCheckoutButtonsBasedOnSelectedSeats = () => {
		const howMany = getHowManySelectedSeats();
		$( '.seatmap-selected .number-of-seats' ).text( howMany );
		if ( 0 < howMany ) {
			$( '.event-schedule-seatmaps .checkout-buttons a' )
				.removeClass( 'disabled' );
		}
		else {
			$( '.event-schedule-seatmaps .checkout-buttons a' )
				.addClass( 'disabled' );
		}
	};

	$( '.seatmap-detail-left-inner' )
		.on( 'click', '.seatmap-inner ul li a', function( event ) {
			event.preventDefault();

			if ( 1 == $( this ).data( 'state' ) ) {
				$( this ).popover( 'show' );
			} else {
				$( this ).popover( 'hide' );
			}
		} );

	$( 'body' ).on( 'click', 'a.seat-ticket', function( event ) {
		event.preventDefault();

		const $this = $( this );
		// Saving data in the href as sata-attributes are stripped from the popover
		const data = $this.attr( 'href' ).split( '|' );
		const [priceBandId, id, type] = data;
		const $dataEl = $( `#${ id }` );

		if ( '' === $dataEl.attr( 'href' ) ) {
			return;
		}

		const selected = $dataEl.data( 'selected' );
		//conditionally check/uncheck

		if ( selected ) {
			modifySeatInputs( priceBandId, id, false );
			$dataEl.css( {
				'box-shadow': 'none',
				'background-color': $dataEl.data( 'color' ),
			} );
			$dataEl.data( 'selected', false );
			$( `#seat-row-${id}` ).remove();
			$this.text( 'Select' );
		}
		else {
			modifySeatInputs( priceBandId, id, true );
			$dataEl.css( {
				'box-shadow': '0 1px 4px 0 #000912',
				'background-color': red61.primary_color,
			} );
			const seat = $dataEl.data( 'seat' );
			const seatNumber = 'number' == typeof seat ? seat : seat.replace( /[a-z-A-Z]/g, '' );
			$( '#selected-seats tbody' ).append( selectedSeatTemplate(
				{
					id: id,
					block: $dataEl.data( 'block' ),
					row: $dataEl.data( 'row' ),
					type: type,
					number: seatNumber,
					priceband: priceBandId,
					removesvg: red61.removesvg,
					translations
				},
			) );
			$this.text( translations[ 'Remove' ] || 'Remove' );
			$dataEl.data( 'selected', true );
		}
		$dataEl.data( 'priceband-id', priceBandId );
		updateCheckoutButtonsBasedOnSelectedSeats();
	} );

	// Seatmaps click handlers
	$( '.event-schedule-seatmaps' )
		.on( 'click', '.back-to-calendar', function( event ) {
			event.preventDefault();
			const splitPath = window.location.pathname.replace( /\/$/, '' ).split( '/' );
			window.location.href = `/${  splitPath.slice( 1, splitPath.length - 1 ).join( '/' )}/`;
		} )
		.on( 'click', '.add-to-basket', async function( event ) {
			event.preventDefault();
			const response = await addSeatsToBasket(
				$( '.checkout-buttons-seats a' ) );
			updateBasketMessageSeating( response.message );
			if ( response.basket ) {
				$( '.cart-btn .price' ).text( response.basket.total );
				$( '.checkout-buttons .checkout' ).removeClass( 'd-none' );
				// clear up things
				$( '.seatmap-selected .number-of-seats' ).text( 0 );

				$( '#selected-seats tbody' ).html( '' );
				// remove selected items
				$( '.seatmap-inner ul li a' ).filter( function() {
					return true === $( this ).data( 'selected' );
				} ).each( function() {
					$( this ).css(
						{
							'background-color': red61.secondary_color,
							'box-shadow': 'none',
						},
					).removeAttr( 'href' );
					$( this ).data( 'selected', false );
					$( this ).data( 'state', 2 );
					$( this ).removeAttr( 'data-content' );
					$( this ).removeAttr( 'tabindex' );
				} );
				if ( $( this ).hasClass( 'checkout' ) ) {
					let languagePathParam = '';
					if ( language !== defaultLanguage ) {
						languagePathParam = `/${language}`;
					}

					window.location.href = `${languagePathParam}/basket`;
				}
			}
		} )
		.on( 'click', '.remove-seat', function( event ) {
			event.preventDefault();
			const $seatLink = $( `a#${$( this ).data( 'id' )}` );
			$seatLink.css(
				{
					'box-shadow': 'none',
					'background-color': $seatLink.data( 'color' ),
				},
			);
			$seatLink.data( 'selected', false );
			modifySeatInputs( $( this ).data( 'priceband' ), $( this ).data( 'id' ),
				false,
			);
			$( this ).closest( 'tr' ).remove();
			updateCheckoutButtonsBasedOnSelectedSeats();
		} );

	async function addSeatsToBasket( $links ) {
		$( '.basket-message' ).addClass( 'd-none' );
		$links.addClass( 'disabled' );
		const formData = new FormData(
			document.querySelector( 'form.seats-form' ) );

		formData.append( 'action', 'add_to_basket' );
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();

		$links.removeClass( 'disabled' );
		return response;
	}

	function modifySeatInputs( priceBandId, id, add = true ) {
		const $seatList = $( `#seat_list_${priceBandId}` );
		let values = $seatList.val().split( ',' );
		if ( add ) {
			values.push( id );
		}
		else {
			values = values.filter( function( value ) {
				return value != id;
			} );
		}
		values = values.filter( function( el ) {
			return '' !== el;
		} );
		$seatList.val( values.join( ',' ) );
		$( `#qty_${priceBandId}` ).val( values.length );
	}

	$( document ).ready( function() {
		$( window ).on( 'popstate', function ( ) {
			location.reload();
		} );
	} );

	/**
	 * Update the inclusive total when the PWYL input value changes.
	 */
	$( document ).on( 'input', '.pay-what-you-like-amount-in-table', function () {
		const $container = $( this ).closest( '.pwyl-with-inclusive-price' );
		const fees       = parseFloat( $container.data( 'fees' ) ) || 0;
		const inputVal   = parseFloat( $( this ).val() ) || 0;
		const currency   = $container.data( 'currency' ) || '';
		const total      = ( inputVal + fees ).toFixed( 2 ).replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
		$container.find( '.pwyl-inclusive-total' ).text( currency + total );
	} );

	/**
	 * Prevent the enter button for submitting the form and tigger the add to basket functionality.
	 */
	$( '.pwyl-input-field-in-table' ).on( 'keypress', function ( e ) {
		if( 13 === e.which ) {
			// prevent the form submission
			e.preventDefault();

			// disable textbox to prevent multiple submit
			$( this ).attr( 'disabled', 'disabled' );

			// click the button to add to basket
			$( this ).closest( 'tr' ).find( 'a' ).click();

			// enable the textbox again.
			$( this ).removeAttr( 'disabled' );
		}
	} );

	function updateBasketMessage( message ) {
		$( '.basket-message' ).text( message.text );
		$( '.basket-message' )
			.attr( 'class', `alert ${message.className} basket-message` );
	}
	function updateBasketMessageSeating( message ) {
		$( '.basket-message' ).removeClass( 'd-none' );
		$( '.basket-message' ).text( message.text );
		$( '.basket-message' )
			.attr( 'class', `alert ${message.className} basket-message` );
	}

	async function addToBasket() {
		const $links = $( '.main_tck a' );
		$( '.basket-message' ).css( 'd-none' );
		$links.addClass( 'disabled' );
		const formData = new FormData(
			document.querySelector( 'form.tickets-form' ) );
		formData.append( 'action', 'add_to_basket' );
		const response = await $.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} ).promise();
		$( '#add-to-basket-spinner' ).addClass( 'd-none' );
		$( '#add-to-basket-text' ).removeClass( 'd-none' );
		$links.removeClass( 'disabled' );
		return response;
	}

	const galleryThumbs = new Swiper( '.gallery-thumbs', {
		spaceBetween: 10,
		slidesPerView: 5,
		loop: true,
		freeMode: true,
		loopedSlides: 5, //looped slides should be the same
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	} );
	new Swiper( '.gallery-top', {
		spaceBetween: 10,
		loop: true,
		loopedSlides: 5, //looped slides should be the same
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		thumbs: {
			swiper: galleryThumbs,
		},
	} );

	$( '.tickets-main' ).on( 'DOMNodeInserted', '#get-access-form-wrapper', async function () {
		makeDigitalGetAccessPageCall();
	} );

	( async () => {
		if( 0 < $( '#get-access-form-wrapper' ).length ) {
			makeDigitalGetAccessPageCall();
		} 
	} )();

	async function makeDigitalGetAccessPageCall() {
		const path = `${window.location.pathname}`;
		const parts = path.split( '/' ).filter( Boolean );
		const perfId = parts[2];
	
		// Only run this code if we are on a perf page and not just an event page
		if( '' != perfId && perfId ) {

			const formData = new FormData();
			formData.append( 'perfId', perfId );
			formData.append( 'action', 'do_create_pwyl_page' );
			
			try {
				const response = await $.ajax( {
					method: 'post',
					processData: false,
					contentType: false,
					cache: false,
					data: formData,
					enctype: 'multipart/form-data',
					url: red61.ajax_url,
				} );

				if ( response ) {
					const tags = response['prePurchaseTags']['tagsArray'];
					const urlFreeAccessBoolean = response['getAccessButtonInfo']['urlFreeAccessBoolean'];
					const priceOverrideBoolean = response['payWhatYouLike']['priceOverrideBoolean'];
					const areFreeTicketsAvailable = response['getAccessButtonInfo']['areFreeTicketsAvailable'];
					const suggestedPWYLAmount = response['payWhatYouLike']['suggestedPWYLAmount'];
			
					if( urlFreeAccessBoolean && areFreeTicketsAvailable ) {
						// The get access btn will show.
						$( '#get-access-form-wrapper' ).removeClass( 'display-none' );
						$( '.ticket-table-container' ).removeClass( 'col-lg-6' );
						$( '.select-ticket-type' ).addClass( 'display-none' );
					} else {
						$( '.row .ticket-info' ).removeClass( 'display-none' );
						$( '.tickets-main .main_tck' ).removeClass( 'display-none' );
					}
			
			
					if( priceOverrideBoolean ) {
						// Customer will be able to PWYL
						$( '.pay-what-you-like-amount' ).removeClass( 'display-none' );
						$( '.pay-what-you-like-title' ).removeClass( 'display-none' );
						$( '.pwyl-currency-symbol' ).removeClass( 'display-none' );
						$( '.pay-what-you-like-amount' ).val( suggestedPWYLAmount );
					}
			
					if( 0 < tags.length ) {
						$( '.pre-performance-tags-div' ).removeClass( 'display-none' );
						$( '.pre-performance-tags-div' )
							.empty()
							.append( displayTags ( { tags } )
							);
					}
				}
			} catch ( e ) {
				return;
			}
			
		}
		
	}

	$( '.back-to-calendar' ).click( function( ) {
		$( '.row .ticket-info' ).addClass( 'display-none' );
		$( '#get-access-form-wrapper' ).addClass( 'display-none' );
		$( '.ticket-table-container' ).addClass( 'col-lg-6' );
	}
	);

	$( '.btn-get-access' ).click( function( event ) {

		const pwylAmount = $( '.pay-what-you-like-amount' ).val();
		const trueIfPWYLIsHidden = $( '.pay-what-you-like-amount' ).hasClass( 'display-none' );

		// validate the input amount only if PWYL input box is not hidden.
		if ( false === trueIfPWYLIsHidden  ) {
			const isValid = validatePayWhatYouWantAmount( pwylAmount );
			if ( !isValid ) {
				event.preventDefault();
			}
		}
	} );


	$( '.get-access-button-wrapper' ).click( function( ) {
		const formData = new FormData();
		formData.append( 'action', 'do_create_get_access_btn_page' );
		$.ajax( {
			method: 'post',
			processData: false,
			contentType: false,
			cache: false,
			data: formData,
			enctype: 'multipart/form-data',
			url: red61.ajax_url,
		} );

	} );

	function validatePayWhatYouWantAmount( pwylAmount ) {
		const numberRegex =  new RegExp( /^\d+$/ );
		const decimalRegex = new RegExp( /^\d+\.\d{0,2}$/ );
		let validFormat = false;
		if ( decimalRegex.test( pwylAmount ) || numberRegex.test( pwylAmount ) ) {
			validFormat =  true;
		}
		if( !validFormat ){
			// display translated error message
			const messageText = translations['Please enter a value in the format of "8" or "8.50"'] || 'Please enter a value in the format of "8" or "8.50"';
			const message = {'text': messageText, 'className': 'alert-danger'};
			updateBasketMessage( message );
		}
		return validFormat;
	}
	
	$( document ).ready( function(){
		$( '.waiting-list-submit-logged-in' ).click( function () {    
			
			const waitingListText = $( '#waiting-list-text-area' ).val();
			const waitingListEventRef = $( '#waiting-list-event-ref' ).val();
			const waitingListCustomerId = $( '#waiting-list-customer-id' ).val();
			
			const data = {
				'action': 'get_waiting_list',
				'waitingListText': waitingListText,
				'waitingListEventRef': waitingListEventRef,
				'waitingListCustomerId': waitingListCustomerId
			};
			
			$.post( red61.ajax_url, data, function( response ) {
				return response;
			} );
		} );
	} );
} );
